export enum SortTypes {
  age = 'Newest',
  price = 'Cheapest',
  title = 'Alphabetically',
}
